/**
 * En-tête de la coquille : navigation en ARBRE à gauche (fil d'Ariane, via le slot
 * `nav`) et rangée d'actions à droite (`actions` : icônes de navigation primaire,
 * cloche, menu de compte). Le wordmark a été retiré — l'icône Maison du fil d'Ariane
 * EST le retour à l'accueil. Sticky.
 *
 * RESPONSIVE — MESURÉ, pas supposé. À 360 px, la rangée d'actions occupe 232 px
 * (4 icônes de navigation + cloche + compte) et ne rétrécit pas : le fil d'Ariane se
 * retrouvait avec 88 px, où CHAQUE maillon était tronqué à ~9 px de texte visible
 * (« Superadmin » : `scrollWidth` 44 → `clientWidth` 9). Pas de débordement grâce au
 * `truncate`, mais un fil INEXPLOITABLE.
 *
 * Correctif : SOUS `sm`, l'en-tête passe sur DEUX LIGNES (actions au-dessus, fil
 * d'Ariane pleine largeur en dessous) ; à partir de `sm` il reprend la rangée unique
 * de 56 px d'origine, où la place ne manque pas.
 */
interface HeaderProps {
  /** Navigation de gauche (fil d'Ariane dérivé de la route). */
  nav?: React.ReactNode;
  /** Actions de fin d'en-tête (icônes de navigation, cloche à venir, menu de compte). */
  actions?: React.ReactNode;
}

export function Header({ nav, actions }: HeaderProps): React.JSX.Element {
  return (
    <header className="z-10 shrink-0 border-b border-border bg-surface/95 backdrop-blur">
      <div className="mx-auto flex min-h-14 max-w-7xl flex-wrap items-center gap-x-2 gap-y-1 px-4 py-1 sm:h-14 sm:flex-nowrap sm:py-0">
        {/* Fil d'Ariane — pleine largeur sur sa propre ligne sous `sm`, flexible et
            tronquable ensuite pour ne pas pousser les actions. `order-last` le place
            SOUS les actions en mode empilé. */}
        {nav && (
          <div className="order-last w-full min-w-0 sm:order-none sm:w-auto sm:flex-1">{nav}</div>
        )}

        {/* Actions — compactes, ne rétrécissent jamais. */}
        <div className="ms-auto flex shrink-0 items-center gap-1">{actions}</div>
      </div>
    </header>
  );
}
